import {BonusBunniesParsedGameData} from "../../server/data/BonusBunniesParsedGameData";
import {BonusBunniesExtraReelWPView} from "./BonusBunniesExtraReelWPView";
import {TimelineLite} from "gsap";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {BonusBunniesGameMode} from "../../gamemode/BonusBunniesGameMode";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BonusBunniesParsedInitData} from "../../server/data/BonusBunniesParsedInitData";
import {LoaderEvent} from "@nolimitcity/slot-game/bin/core/resource/event/LoaderEvent";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";

/**
 * Created by Jerker Nord on 2019-09-02.
 */

export class BonusBunniesExtraReelWPController extends WinPresentationController {

    private _lastReelActivationPlayed:boolean = false;
    private _lastReelActivated:boolean = false;
    private _bottomRowActivated:boolean = false;
    private _extraReelTL:TimelineLite;
    private _isRestore:boolean;
    private _doRestore:boolean;
    private _view:BonusBunniesExtraReelWPView;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "BonusBunniesExtraReelWPController", skippable : false});
        this._view = new BonusBunniesExtraReelWPView();
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, LoaderEvent.RESOURCES_LOADED, (event:LoaderEvent) => this.onResourcesLoaded(event));
    }

    private onResourcesLoaded(event:LoaderEvent):void {
        if(event.key != ResourcesGroupName.MAIN) {
            return;
        }
        if(this._doRestore == true) {
            this.doAbort();
            this._doRestore = false;
        }
    }

    private onInitDataParsed(data:BonusBunniesParsedInitData):void {
        this._isRestore = data.isRestoreState;
        this._lastReelActivated = data.lastReelActivated;
        this._bottomRowActivated = data.bottomRowActivated;
        this._doRestore = false;
        if(this._lastReelActivated == true && this._lastReelActivationPlayed == false && this._isRestore == true) {
            this._doRestore = true;
        }
    }

    protected parseFeatureGameData(data:BonusBunniesParsedGameData):void {
        this._lastReelActivated = data.lastReelActivated;
        this._bottomRowActivated = data.bottomRowActivated;
    }

    protected hasWin():boolean {
        if(this._lastReelActivated == true && this._lastReelActivationPlayed == false && this._doRestore == false) {
            return true;
        } else {
            if(this._gameData!.mode == BonusBunniesGameMode.BONUS_GAME && this._gameData!.nextMode == BonusBunniesGameMode.NORMAL) {
                this._lastReelActivationPlayed = false;
            }
            return false;
        }
    }

    public disableExtraReel():void {
        this._view.disableExtraReel();
    }

    protected startWinPresentation():void {
        if(this._extraReelTL && this._extraReelTL.isActive()) {
            this._extraReelTL.pause();
            this._extraReelTL.kill();
        }
        this._extraReelTL = new TimelineLite();
        this._extraReelTL.add(() => this._view.getWinAnimationTL(this._bottomRowActivated));
        this._extraReelTL.add(() => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_EXPAND_REELS));
        if(this._bottomRowActivated == true) {
            this._extraReelTL.add(() => this._view.enableExtra5Reel());
            this._extraReelTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesLayerController.animateExtraReelRowZoom());
            this._extraReelTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesSpinController.enableLastBonusReel());
            this._extraReelTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesSpinController.enableLastBonusReelAndRow());
            this._extraReelTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsCounterView.extraReelActivated = true);
            this._extraReelTL.add(() => this.showBonusGameExtraReelAndRow());
        } else {
            this._extraReelTL.add(() => this._view.enableExtra4Reel());
            this._extraReelTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesLayerController.animateExtraReel());
            this._extraReelTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesSpinController.enableLastBonusReel());
            this._extraReelTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsCounterView.extraReelActivated = true);
            this._extraReelTL.add(() => this.showBonusGameExtraReel());
        }
        this._extraReelTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPView.extraReelActivated = true);
        this._extraReelTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsChestController.setExtraReelActivated(true));
        this._extraReelTL.add(() => this.finish(), "+=1.5");
        this._extraReelTL.add(() => this._lastReelActivationPlayed = true);
    }

    private showBonusGameExtraReel():void {
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.showReel(20);
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.showReel(21);
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.showReel(22);
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.showReel(23);

    }

    private showBonusGameExtraReelAndRow():void {
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.showReel(20);
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.showReel(21);
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.showReel(22);
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.showReel(23);
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.showReel(24);
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(isAborted == true) {
            if(this._extraReelTL && this._extraReelTL.isActive()) {
                this._extraReelTL.pause();
                this._extraReelTL.kill();
            }
            this._view.abortWinAnimation();
            this.doAbort();
        }
    }

    //Also used by restore
    private doAbort():void {
        if(this._bottomRowActivated == true) {
            this._view.abortEnableExtra5Reel();
            BonusBunniesGameModuleConfig.bonusBunniesLayerController.setLayersExtraReelRowEnabled();
            //If restore this will be handled by Spin Controller
            if(this._doRestore == false) {
                BonusBunniesGameModuleConfig.bonusBunniesSpinController.enableLastBonusReel();
                BonusBunniesGameModuleConfig.bonusBunniesSpinController.enableLastBonusReelAndRow();
            }
            BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsCounterView.extraReelActivated = true;
            this.showBonusGameExtraReelAndRow();
            BonusBunniesGameModuleConfig.bonusBunniesBonusGameInfoPlate.set5RowPosition();
            BonusBunniesGameModuleConfig.bonusBunniesBonusGameInfoPlate.setExtraReelPositionAndScale();
            BonusBunniesGameModuleConfig.bonusBunniesBonusGameInfoPlate.enableInfo();
        } else {
            //Enables grid GFX
            this._view.abortEnableExtra4Reel();
            //Zoom layers
            BonusBunniesGameModuleConfig.bonusBunniesLayerController.setLayersExtraReelEnabled();
            //If restore this will be handled by Spin Controller
            if(this._doRestore == false) {
                BonusBunniesGameModuleConfig.bonusBunniesSpinController.enableLastBonusReel();
            }
            BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsCounterView.extraReelActivated = true;
            this.showBonusGameExtraReel();
            BonusBunniesGameModuleConfig.bonusBunniesBonusGameInfoPlate.set4RowPosition();
            BonusBunniesGameModuleConfig.bonusBunniesBonusGameInfoPlate.setExtraReelPositionAndScale();
            BonusBunniesGameModuleConfig.bonusBunniesBonusGameInfoPlate.enableInfo();
        }
        BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPView.extraReelActivated = true;
        BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsChestController.setExtraReelActivated(true);
        this._lastReelActivationPlayed = true;
    }


    get lastReelActivationPlayed():boolean {
        return this._lastReelActivationPlayed;
    }
}